/**
 * @generated SignedSource<<9567043cf423dfbef8551939c0c970b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternNotificationsCardCreateHubMutation$variables = {
  brandId: string;
  hubName?: string | null;
};
export type InternNotificationsCardCreateHubMutation$data = {
  readonly createAzureNotificationHub: {
    readonly azureNotificationsHubName: string;
    readonly id: string;
  };
};
export type InternNotificationsCardCreateHubMutation = {
  response: InternNotificationsCardCreateHubMutation$data;
  variables: InternNotificationsCardCreateHubMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      },
      {
        "kind": "Variable",
        "name": "hubName",
        "variableName": "hubName"
      }
    ],
    "concreteType": "BrandAppConfigType",
    "kind": "LinkedField",
    "name": "createAzureNotificationHub",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "azureNotificationsHubName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternNotificationsCardCreateHubMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternNotificationsCardCreateHubMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "18f274c8ba820eae72d1da756e720ee7",
    "id": null,
    "metadata": {},
    "name": "InternNotificationsCardCreateHubMutation",
    "operationKind": "mutation",
    "text": "mutation InternNotificationsCardCreateHubMutation(\n  $brandId: ID!\n  $hubName: String\n) {\n  createAzureNotificationHub(brandId: $brandId, hubName: $hubName) {\n    id\n    azureNotificationsHubName\n  }\n}\n"
  }
};
})();

(node as any).hash = "24ec986cb367d93a1490c971f50ce2c7";

export default node;
